<script setup lang="ts">
import { computed } from "vue";

type Segment = { text: string; hit: boolean };

const props = withDefaults(defineProps<{ text?: string; query?: string }>(), {
  text: "",
  query: "",
});

const segments = computed<Segment[]>(() => {
  if (!props.text) return [];
  const query = props.query.trim().toLowerCase();
  const index = query ? props.text.toLowerCase().indexOf(query) : -1;
  if (index === -1) return [{ text: props.text, hit: false }];
  return [
    { text: props.text.slice(0, index), hit: false },
    { text: props.text.slice(index, index + query.length), hit: true },
    { text: props.text.slice(index + query.length), hit: false },
  ].filter((segment) => segment.text.length > 0);
});
</script>

<template>
  <template v-for="(segment, index) in segments" :key="index"
    ><mark v-if="segment.hit" class="rounded-sm bg-teal-900/20 text-inherit">{{ segment.text }}</mark
    ><template v-else>{{ segment.text }}</template></template
  >
</template>
